<template>
	<div :class="_class" :style="_style" @click="$emit('click', $event)" @mouseenter="$emit('mouseenter', $event)" @mouseleave="$emit('mouseleave', $event)">
		<div class="type-wrapper" v-if="bgUrl">
			<slot></slot>
		</div>
		<slot v-else></slot>
	</div>
</template>

<script>
    // 整块的包装
	export default {
		name: 'type-wrapper',
		props: {
			bgUrl: {
				type: String,
				default: ''
			},
            // 限制宽度
			limit: {
				type: Boolean,
				default: false
			},
			padding: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			_style() {
				if (this.bgUrl) {
					return `
						color: #FFFFFF;
						overflow: hidden;
						background-image: url(${this.bgUrl});
						background-attachment: fixed;
						background-position: center center;
                        background-repeat: no-repeat;
						background-size: cover;
					`;
				}
				return `
					color: #000000;
					background-color: #FFFFFF;
				`;
			},
			_class() {
				if (this.limit) {
					return 'wrapper-limit';
				}
				if (this.padding) {
					return 'wrapper-padding';
				}
				return '';
			}
		}
	}
</script>

<style scoped lang="less">
	.type-wrapper{
		display: inherit;
		flex-wrap: inherit;
		align-items: inherit;
		justify-content: inherit;
		position: relative;
		z-index: 1;
        // 给背景添加一层透明度，一定要够长够宽
		&::before{
			content: '';
			width: 750vw;
			height: 750vh;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			z-index: -2;
			background-color: rgba(0, 0, 0, 0.45);
		}
        // &::after{
        // 	content: '';
        // 	position: absolute;
        //     top: 0;
        //     left: 0;
        //     right: 0;
        //     bottom: 0;
        // 	z-index: -1;
        //     background-image: inherit;
        //     background-position: center center;
        //     background-repeat: no-repeat;
        //     background-size: cover;
        // }
	}
	@media screen and (min-width: 1400px){
		.wrapper-padding{
			padding: 60px;
		}
		.wrapper-limit{
			padding: 60px calc(50% - 640px);
		}
	}
	@media screen and (min-width: 1280px) and (max-width: 1399px){
		.wrapper-padding, .wrapper-limit{
			padding: 60px;
		}
	}
	@media screen and (min-width: 1080px) and (max-width: 1279px){
		.wrapper-limit, .wrapper-padding{
			padding: 50px;
		}
	}
	@media screen and (min-width: 720px) and (max-width: 1079px){
		.wrapper-limit, .wrapper-padding{
			padding: 40px;
		}
	}
	@media screen and (min-width: 560px) and (max-width: 719px){
		.wrapper-limit, .wrapper-padding{
			padding: 30px;
		}
	}
	@media screen and (max-width: 559px){
		.wrapper-limit, .wrapper-padding{
			padding: 20px;
		}
	}
</style>
